// extracted by mini-css-extract-plugin
module.exports = {"top":"Intro_top__1fUXO","apps":"Intro_apps__yL8Qd","left":"Intro_left__2TV91","items":"Intro_items__3idL7"};